import type { ReportedHours } from "@predoc/domain";

export function koreanWeekday(now: Date): ReportedHours["weekly"][number]["day"] {
  return new Intl.DateTimeFormat("ko-KR", { weekday: "short", timeZone: "Asia/Seoul" }).format(now) as ReportedHours["weekly"][number]["day"];
}

// Weekday registration is not a holiday calendar or a live opening signal.
// Free-form reception/closure text stays verbatim; never infer closing/open status.
export function visitPreparation(hours: ReportedHours | null, now: Date) {
  const day = koreanWeekday(now);
  const weekly = hours?.weekly.find((entry) => entry.day === day);
  const labels = day === "토" ? ["토요일 접수", "토요일 점심", "공휴일 휴진 안내"]
    : day === "일" ? ["일요일 휴진 안내", "공휴일 휴진 안내"] : ["평일 접수", "평일 점심", "공휴일 휴진 안내"];
  const notes = hours?.notes.filter((note) => labels.includes(note.label)) ?? [];
  if (day === "토" && hours?.saturdayLunch !== undefined) notes.push({ label: "토요일 점심", text: hours.saturdayLunch });
  return { day, weekly, notes };
}
